import MissileLottery from "../../Pages/User/missile-lottery/index";

export default MissileLottery;
export { MissileLottery };
